import axios from 'axios';
import { format } from 'date-fns';

class CashJournalService {
    constructor() {
        this.baseURL = `${import.meta.env.VITE_API_BASE_URL}/cpanel/cash-journals`;
    }

    async getJournals(params = {}) {
        try {
            const queryParams = { ...params };

            const response = await axios.get(this.baseURL, {
                params: queryParams,
                withCredentials: true,
            });
            return response.data;
        } catch (error) {
            this.handleError(error, 'Failed to fetch cash journals');
            throw error;
        }
    }

    async getJournal(uuid) {
        try {
            const response = await axios.get(`${this.baseURL}/${uuid}`, {
                withCredentials: true,
            });
            return response.data;
        } catch (error) {
            this.handleError(error, 'Failed to fetch cash journal');
            throw error;
        }
    }

    async getJournalStatus(uuid) {
        try {
            const response = await axios.get(`${this.baseURL}/${uuid}/status`, {
                withCredentials: true,
            });
            return response.data;
        } catch (error) {
            this.handleError(error, 'Failed to fetch journal status');
            throw error;
        }
    }

    async getTransactions(params = {}) {
        try {
            const queryParams = { ...params };

            if (queryParams.startDate instanceof Date) {
                queryParams.startDate = format(queryParams.startDate, 'yyyy-MM-dd');
            }
            if (queryParams.endDate instanceof Date) {
                queryParams.endDate = format(queryParams.endDate, 'yyyy-MM-dd');
            }

            const response = await axios.get(
                `${import.meta.env.VITE_API_BASE_URL}/cpanel/cash-journal-transactions`,
                {
                    params: queryParams,
                    withCredentials: true,
                },
            );
            return response.data;
        } catch (error) {
            this.handleError(error, 'Failed to fetch cash journal transactions');
            throw error;
        }
    }

    async getTransaction(uuid) {
        try {
            const response = await axios.get(
                `${import.meta.env.VITE_API_BASE_URL}/cpanel/cash-journal-transactions/${uuid}`,
                {
                    withCredentials: true,
                },
            );
            return response.data;
        } catch (error) {
            this.handleError(error, 'Failed to fetch cash journal transaction');
            throw error;
        }
    }

    async getReports(params = {}) {
        try {
            const queryParams = { ...params };

            if (queryParams.startDate instanceof Date) {
                queryParams.startDate = format(queryParams.startDate, 'yyyy-MM-dd');
            }
            if (queryParams.endDate instanceof Date) {
                queryParams.endDate = format(queryParams.endDate, 'yyyy-MM-dd');
            }

            const response = await axios.get(
                `${import.meta.env.VITE_API_BASE_URL}/cpanel/cash-journal-reports`,
                {
                    params: queryParams,
                    withCredentials: true,
                },
            );
            return response.data;
        } catch (error) {
            this.handleError(error, 'Failed to fetch cash journal reports');
            throw error;
        }
    }

    async getReport(uuid) {
        try {
            const response = await axios.get(
                `${import.meta.env.VITE_API_BASE_URL}/cpanel/cash-journal-reports/${uuid}`,
                {
                    withCredentials: true,
                },
            );
            return response.data;
        } catch (error) {
            this.handleError(error, 'Failed to fetch cash journal report');
            throw error;
        }
    }

    handleError(error, message) {
        if (error.response) {
            const status = error.response.status;
            const data = error.response.data;

            switch (status) {
                case 400:
                    console.error(`${message}: Invalid data`, data);
                    break;
                case 401:
                    console.error(`${message}: Authentication required`);
                    break;
                case 404:
                    console.error(`${message}: Resource not found`);
                    break;
                case 500:
                    console.error(`${message}: Server error`, data);
                    break;
                default:
                    console.error(`${message}: HTTP ${status}`, data);
            }
        } else if (error.request) {
            console.error(`${message}: Network error`, error.request);
        } else {
            console.error(`${message}:`, error.message);
        }
    }
}

const cashJournalService = new CashJournalService();
export default cashJournalService;
